import axios from "axios"
import { BASE_URL } from '../constants/urlConstants'
import { LOGO_LIST_FAIL,
         LOGO_LIST_REQUEST,
         LOGO_LIST_SUCCESS } from "../constants/logoConstansts"


  
  export const fetchLogo = () => async(dispatch) => {
    try{
        dispatch({type: LOGO_LIST_REQUEST})

        const { data } = await axios.get(`${BASE_URL}/logo/`)
        dispatch({type: LOGO_LIST_SUCCESS , payload: data})

    }catch(error){
        dispatch({type: LOGO_LIST_FAIL,
            payload: error.response && error.response.data.message
                ? error.response.data.message
                : error.message
        })

    }

  }



  
  
  

  
  

  
  
  
  
  
  

  

  



